import moment from "moment";

export default () => moment().format("HH:mm:ss.SSS");
